export default {
  data() {
    return {
      page: 1,
      size: 40,
      totalCount: 0,
    };
  },
  methods: {
    generateLink(page) {
      return {
        query: { page: page || 1, size: this.size },
      };
    },
    generateNumberOfPages() {
      let count = this.totalCount / this.size + 1;
      if (this.totalCount % this.size === 0) {
        count -= 1;
      }
      return count;
    },
  },
  watch: {
    "$route.query"() {
      this.loadData();
    },
  },
};
